import { useState } from 'react';

import { LocalStorage } from 'components/Common/Utils/local_storage';

const LOCAL_STORAGE_KEY = 'homepage_optin_state';
const HOMEPAGE = 'homepage';
const DASHBOARD = 'dashboard';
const LOCAL_STORAGE_KEY_SWITCH_BACK_MODAL = 'homepage_optin_switch_back_modal';

export const useHomepageOptin = () => {
  const currentOptinState = LocalStorage.getItem(LOCAL_STORAGE_KEY) || DASHBOARD;
  const [isHomepageOptedin, setHomepageOptedin] = useState(currentOptinState === HOMEPAGE);
  const currentStateSwitchBackModal = LocalStorage.getItem(LOCAL_STORAGE_KEY_SWITCH_BACK_MODAL) || false;
  const [stateSwitchBackModal, setStateSwitchBackModal] = useState(currentStateSwitchBackModal);

  const setHomepageAsDefault = () => {
    LocalStorage.setItem(LOCAL_STORAGE_KEY, HOMEPAGE);
    setHomepageOptedin(true);
  };

  const setDashboardAsDefault = () => {
    LocalStorage.setItem(LOCAL_STORAGE_KEY, DASHBOARD);
    setHomepageOptedin(false);
  };

  const setShowSwitchBackModal = () => {
    LocalStorage.setItem(LOCAL_STORAGE_KEY_SWITCH_BACK_MODAL, true);
    setStateSwitchBackModal(true);
  };

  const setHideSwitchBackModal = () => {
    LocalStorage.removeItem(LOCAL_STORAGE_KEY_SWITCH_BACK_MODAL);
    setStateSwitchBackModal(false);
  };

  return {
    setHomepageAsDefault,
    setDashboardAsDefault,
    isHomepageOptedin,
    setShowSwitchBackModal,
    setHideSwitchBackModal,
    stateSwitchBackModal,
  };
};
